import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';

import deleteIcon from 'images/icons/invite/delete.svg';
import Tooltip from 'components/ui/Tooltip';
import { useContext } from '../Context';

export default function DeleteButton({ affiliateTrainingStep }) {
  const { dispatch, actions } = useContext();

  const destroyAffiliateTrainingStep = (e) => {
    swal(
      {
        title: '',
        text: `Do you want to delete ${affiliateTrainingStep.attributes.title}?`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        closeOnConfirm: true,
        closeOnCancel: true,
      },
      (isConfirm) => {
        if (isConfirm) {
          let el = e.target;
          while (el && el.tagName !== 'BUTTON') {
            el = el.parentNode;
          }

          el.innerHTML = '<i class="fa fa-spinner fa-spin"></i>';
          actions.destroy(dispatch, affiliateTrainingStep.id);
        }
      },
    );
  };

  return (
    <>
      <Button
        bsStyle="link"
        style={{ padding: 0 }}
        onClick={(e) => destroyAffiliateTrainingStep(e)}
        data-tip="Delete"
      >
        <img src={deleteIcon} alt="delete affiliate training step" />
      </Button>

      <Tooltip />
    </>
  );
}

DeleteButton.propTypes = {
  affiliateTrainingStep: PropTypes.object.isRequired,
};
